<template>
  <div class="more-projects">
    <h4 class="title">More {{categories}}</h4>
    <div class="projects-container">
      <div v-for="project in projects" :key="project.id" class="project-item">
        <project-banner :project="project"></project-banner>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectBanner from './ProjectBanner';

export default {
  name: 'more-projects',
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  components: {
    ProjectBanner
  },
  computed: {
    categories () {
      const categories = this.$props.project.categories
        .map(c => c.name)
          .join(', ');

      return categories;
    },
    projects () {
      const projects = this.$props.project.categories
        .map(c => this.$store.getters.projects
          .filter(p => p.categories
            .find(cd => cd.id === c.id)))[0]
              .filter(p => p.id !== this.$props.project.id);

      return projects;
    }
  }
}
</script>

<style lang="scss">
.more-projects {
  display: flex;
  flex-direction: column;
  width: 100%;

  .title {
    margin-top: 2rem;
    margin-bottom: 1rem;
  }

  .projects-container {
    display: flex;
    flex-flow: wrap;
    width: 100%;

    .project-item {
      @media only screen and (max-width: 512px) {
        width: 33.333%;
      }
      width: 25%;
    }
  }
}
</style>




// WEBPACK FOOTER //
// MoreProjects.vue?43b173db